import React from 'react';
import { certTexts } from '../contexts/LangMOB';
import iso9001Img from '../assets/images/mobileum/iso9001.png';
import isoiec27001roamingImg from '../assets/images/mobileum/isoiec27001Roaming.png';
import isoiec27001riskImg from '../assets/images/mobileum/isoiec27001Risk.png';
import ioImg from '../assets/images/mobileum/io.png';

function ProductMOBCertification({ lang = 'ko', isMobile = false, certRef, certVisible }) {
  const certifications = [
    { key: 'iso9001', text: certTexts.cert.iso9001, img: iso9001Img, alt: 'ISO 9001' },
    { key: 'isoiec27001roaming', text: certTexts.cert.isoiec27001roaming, img: isoiec27001roamingImg, alt: 'ISO/IEC 27001 Roaming' },
    { key: 'isoiec27001risk', text: certTexts.cert.isoiec27001risk, img: isoiec27001riskImg, alt: 'ISO/IEC 27001 Risk' },
    { key: 'io', text: certTexts.cert.io, img: ioImg, alt: 'IO' },
  ];

  return (
    <div
      ref={certRef}
      style={{
        width: '100%',
        maxWidth: '100vw',
        // background: '#fff',
        background: 'rgba(255, 255, 255, 0.9)',
        // borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '20px 16px' : '32px 40px',
        boxSizing: 'border-box',
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.5rem' : '2rem',
        fontWeight: 700,
        color: '#09225C',
        marginBottom: isMobile ? 12 : 24,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        {certTexts.title[lang]}
      </span>
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '12px' : '16px',
          width: '100%',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}
      >
        {certifications.map((item, idx) => (
          <div
            key={item.key}
            style={{
              background: 'transparent',
              borderRadius: 10,
              padding: isMobile ? '16px 12px' : '20px 16px',
              minWidth: isMobile ? '100%' : '200px',
              maxWidth: isMobile ? '100%' : '280px',
              flex: isMobile ? '1 1 100%' : '1 1 0',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              transition: 'all 0.7s cubic-bezier(0.23, 1, 0.32, 1)',
              opacity: certVisible ? 1 : 0,
              transform: certVisible ? 'translateY(0)' : 'translateY(40px)',
              transitionDelay: certVisible ? `${idx * 0.12}s` : '0s'
            }}
          >
            <img
              src={item.img}
              alt={item.alt}
              style={{
                width: isMobile ? '120px' : '160px',
                height: isMobile ? '120px' : '160px',
                objectFit: 'contain',
                marginBottom: '12px'
              }}
            />
            <div style={{
              fontWeight: 600,
              fontSize: isMobile ? '0.85rem' : '0.95rem',
              color: '#09225C',
              lineHeight: 1.4
            }}>
              {item.text[lang]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductMOBCertification;
